import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-10 col-sm-10 col-lg-10 offset-sm-1 offset-lg-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-2 fw-bold mt-8 mb-7 ml-xs-7" }, "Agenda tu cita", -1)
const _hoisted_4 = { class: "card mb-10" }
const _hoisted_5 = { class: "card-header py-5 bg-dark-site" }
const _hoisted_6 = { class: "row align-items-center w-100" }
const _hoisted_7 = { class: "col-lg-7 col-9 text-end text-lg-start" }
const _hoisted_8 = { class: "fs-2 fw-bold" }
const _hoisted_9 = { class: "mb-0 text-gray" }
const _hoisted_10 = { class: "col-lg-5 col-9 ms-auto" }
const _hoisted_11 = { class: "float-end pt-4 pr-4" }
const _hoisted_12 = { class: "px-4" }
const _hoisted_13 = { class: "fs-2 fw-bold" }
const _hoisted_14 = { class: "card-body rounded-bottom bg-gray-site" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-4 border-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bold" }, "Fecha"),
  /*#__PURE__*/_createElementVNode("p", { class: "fs-base" }, "Selecciona la fecha de tu cita")
], -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_20 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-4 border-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bold" }, "Horario", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "fs-base" }, "Selecciona tu hora de llegada", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold" }, "Por la mañana (am)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold mt-3" }, "Por la tarde (pm)", -1)
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-4 lastColumn" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "row"
}
const _hoisted_30 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_address",
  class: "btn btn-transparent btn-lg col-12 mb-5 border-dotted"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-location text-white" }),
  /*#__PURE__*/_createTextVNode(" Agregar dirección ")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-2\"><div class=\"d-flex justify-content-center align-items-center w-40px h-40px w-md-50px h-md-50px rounded-3 bg-gray-lighten\"><i class=\"isax-location text-white fs-2\"></i></div></div><div class=\"col-md-5\"><p>Dirección</p></div><div class=\"col-md-5 d-flex justify-content-end\"><a class=\"fs-sm\" href=\"javascript: void(0);\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_add_address\">Editar</a></div></div>", 1)
const _hoisted_34 = {
  class: "row",
  style: {"margin-top":"-25px !important"}
}
const _hoisted_35 = { class: "col-md-10 offset-md-2" }
const _hoisted_36 = { class: "text-gray" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = { class: "row px-4 pt-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_42 = {
  class: "modal fade",
  ref: "ModalRef",
  id: "kt_modal_add_address",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_44 = { class: "modal-content" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header px-5 py-4\"><div class=\"w-100 mx-lg-15 d-flex justify-content-between align-items-center\"><h2 class=\"fs-2 fw-bold\">Agregar dirección</h2><div class=\"btn btn-sm btn-icon btn-active-color-primary\" data-bs-dismiss=\"modal\"><i class=\"isax-close-circle text-white fs-2x\"></i></div></div></div>", 1)
const _hoisted_46 = { class: "modal-body scroll-y mx-5 mx-xl-15 mb-7" }
const _hoisted_47 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Código postal", -1)
const _hoisted_49 = { class: "position-relative" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-12" }
const _hoisted_54 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Estado")
], -1)
const _hoisted_56 = { class: "position-relative" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona un estado", -1)
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "col-lg-12" }
const _hoisted_62 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Ciudad")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona una ciudad", -1)
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Dirección", -1)
const _hoisted_70 = { class: "position-relative" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "d-flex mb-7 fv-row align-content-center flex-wrap" }
const _hoisted_74 = { class: "col-md-6 align-self-start px-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Número exterior", -1)
const _hoisted_76 = { class: "position-relative" }
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = { class: "col-md-6 align-self-end px-2" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold form-label mb-2" }, "Número interior", -1)
const _hoisted_81 = { class: "position-relative" }
const _hoisted_82 = { class: "fv-plugins-message-container" }
const _hoisted_83 = { class: "fv-help-block" }
const _hoisted_84 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold form-label mb-2" }, "Calles que cruzan", -1)
const _hoisted_86 = { class: "position-relative" }
const _hoisted_87 = { class: "fv-plugins-message-container" }
const _hoisted_88 = { class: "fv-help-block" }
const _hoisted_89 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Colonia", -1)
const _hoisted_91 = { class: "position-relative" }
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = { class: "d-flex justify-content-end pt-5" }
const _hoisted_95 = {
  type: "reset",
  ref: "resetForm",
  "data-bs-dismiss": "modal",
  class: "btn btn-secondary w-40 mx-4"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Descartar", -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = {
  ref: "submitButtonRef",
  type: "button",
  id: "kt_modal_add_car_submit",
  "data-bs-dismiss": "modal",
  class: "btn btn-primary w-60"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base" }, " Agregar dirección", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Enviando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_101 = [
  _hoisted_99,
  _hoisted_100
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ScheduleResume = _resolveComponent("ScheduleResume")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          role: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returned())),
          class: "svg-icon svg-icon-1hx pointer fs-base"
        }, _toDisplayString("❮ Volver")),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.vehicle.brand) + " " + _toDisplayString(_ctx.vehicle.model) + " " + _toDisplayString(_ctx.vehicle.version), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.vehicle.year) + " - " + _toDisplayString(_ctx.kmFormat(_ctx.vehicle.Mileage)) + " km - " + _toDisplayString(_ctx.vehicle.model), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.tituloHeader), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_DatePicker, {
                      "is-expanded": "",
                      "available-dates": _ctx.calendarDates,
                      color: "blue",
                      modelValue: _ctx.day,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.day) = $event)),
                      "is-dark": "",
                      onDayclick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDay($event)))
                    }, null, 8, ["available-dates", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.hoursDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.hoursDate) = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (time) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: time.id
                      }, [
                        (parseInt(time.hora.slice(0, 2)) < 12)
                          ? (_openBlock(), _createBlock(_component_el_radio_button, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.setTime(time)),
                              label: time.hora,
                              class: "mx-2 rounded fs-2 my-3"
                            }, null, 8, ["onClick", "label"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_24,
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.hoursDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hoursDate) = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (time) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: time.id
                      }, [
                        (parseInt(time.hora.slice(0, 2)) >= 12)
                          ? (_openBlock(), _createBlock(_component_el_radio_button, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.setTime(time)),
                              label: time.hora,
                              class: "mx-2 rounded fs-2 my-3"
                            }, null, 8, ["onClick", "label"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_ScheduleResume, {
                      title: 'Schedule Resume',
                      data: _ctx.schedule
                    }, null, 8, ["data"])
                  ])
                ]),
                _hoisted_28,
                (_ctx.schedule.appointment.tipo == '3')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (!_ctx.schedule.customer.Address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                        : _createCommentVNode("", true),
                      (_ctx.schedule.customer.Address)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("small", _hoisted_36, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.schedule.customer.Address), 1),
                                  _createTextVNode("  "),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.schedule.customer.OutSideNumber) + " " + _toDisplayString(_ctx.schedule.customer.InsideNumber), 1),
                                  _hoisted_37,
                                  (_ctx.schedule.customer.Between)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.schedule.customer.Between), 1),
                                        _hoisted_38
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.schedule.customer.Colony), 1),
                                  _hoisted_39,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.schedule.customer.City) + " " + _toDisplayString(_ctx.schedule.customer.State), 1)
                                ])
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmSave())),
                    type: "button",
                    class: "btn btn-primary btn-lg btn-block"
                  }, [
                    _hoisted_41,
                    _createTextVNode(" Agendar cita ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Form, {
              id: "kt_modal_form_add_address",
              class: "form mx-3",
              ref: "formAddress",
              novalidate: "novalidate",
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control fs-base form-control-solid border-1 border-secondary",
                      name: "postal_zip",
                      placeholder: "Ingresa el código postal",
                      modelValue: _ctx.schedule.customer.CP,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.schedule.customer.CP) = $event)),
                      maxlength: "5"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_ErrorMessage, { name: "CP" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_Field, {
                          as: "select",
                          onChange: _ctx.getCities,
                          class: "form-select form-select-solid fs-base border-1 border-secondary",
                          name: "state",
                          modelValue: _ctx.schedule.customer.idState,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.schedule.customer.idState) = $event)),
                          disabled: _ctx.schedule.customer.idState
                        }, {
                          default: _withCtx(() => [
                            _hoisted_57,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: state.id,
                                value: state.id
                              }, _toDisplayString(state.name), 9, _hoisted_58))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["onChange", "modelValue", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_ErrorMessage, { name: "state" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_Field, {
                        as: "select",
                        onChange: _ctx.setCity,
                        class: "form-select form-select-solid fs-base border-1 border-secondary ps-5",
                        name: "model",
                        modelValue: _ctx.schedule.customer.idCity,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.schedule.customer.idCity) = $event)),
                        disabled: _ctx.schedule.customer.idCity
                      }, {
                        default: _withCtx(() => [
                          _hoisted_64,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: city.id,
                              value: city.id
                            }, _toDisplayString(city.name), 9, _hoisted_65))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onChange", "modelValue", "disabled"]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_ErrorMessage, { name: "city" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid fs-base border-1 border-secondary",
                      name: "address",
                      placeholder: "Ingresa la dirección de la agencia",
                      modelValue: _ctx.schedule.customer.Address,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.schedule.customer.Address) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_ErrorMessage, { name: "address" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid fs-base border-1 border-secondary",
                        name: "outside_numer",
                        placeholder: "# 0000",
                        modelValue: _ctx.schedule.customer.OutSideNumber,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.schedule.customer.OutSideNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_ErrorMessage, { name: "outside_numer" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid fs-base border-1 border-secondary",
                        name: "inside_numer",
                        placeholder: "# 0000",
                        modelValue: _ctx.schedule.customer.InsideNumber,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.schedule.customer.InsideNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createVNode(_component_ErrorMessage, { name: "inside_numer" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _createElementVNode("div", _hoisted_86, [
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid fs-base border-1 border-secondary",
                      name: "bettwen",
                      placeholder: "Ingresa la dirección de la agencia",
                      modelValue: _ctx.schedule.customer.Between,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.schedule.customer.Between) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_ErrorMessage, { name: "bettwen" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _hoisted_90,
                  _createElementVNode("div", _hoisted_91, [
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid fs-base border-1 border-secondary",
                      name: "colony",
                      placeholder: "Ingresa la colonia",
                      modelValue: _ctx.schedule.customer.Colony,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.schedule.customer.Colony) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _createVNode(_component_ErrorMessage, { name: "colony" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("button", _hoisted_95, _hoisted_97, 512),
                  _createElementVNode("button", _hoisted_98, _hoisted_101, 512)
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}